import React from "react";
import CrudManager from "../../utils/Crud-Manager/CrudManager";
import schema from "./Data/UsersCRUDConfig.json";
import { Box } from "@mui/material";
import PageHeader from "../../components/PageHeader";
const UsersPage = () => {
  return (
    <Box sx={{ display: "flex" }}>
      <Box sx={{ flexGrow: 1, marginTop:0, marginLeft: 15,  marginRight: 15, marginBottom:15}} >
      <PageHeader pageTitle="Manage Users" />
        <CrudManager
          data={schema}
          actionBtnName="Add New User"
          createFormTitle="Add User"
          updateFormTitle="Update User"
        />
      </Box>
    </Box>
  );
};

export default UsersPage;
